const postalCodeRegex = /^(?:[0-8]\d|9[0-8])\d{3}$/;

function isValidAddress(form) {
  return form;
}

export function isUnknownStreet(form) {
  return isValidAddress(form)
    && form.address
    && form.address.street
    && form.address.street === '-';
}

function isValidPostal(form) {
  return isValidAddress(form)
    && form.address
    && form.address.postal
    && form.address.postal.match(postalCodeRegex);
}

function isValidCity(form) {
  return isValidAddress(form) && form.address.city && form.address.city !== '';
}

function isValidFloor(form) {
  return form && form.floor && form.floor.floor;
}

export function isSpecialLogementType(logement_type) {
  return logement_type === 'DGTS_LOG_GARDEMEUBLE';
}

export function isUnknownLogementType(logement_type) {
  return logement_type === 'DGTS_LOG_UNDEFINED';
}

export function addressMutation(storeName) {
  return {
    SET_STREET(state, street) {
      state[storeName].address.street = street;
    },
    SET_POSTAL(state, postalCode) {
      state[storeName].address.postal = postalCode;
    },
    SET_CITY(state, city) {
      state[storeName].address.city = city;
    },
    SET_TYPES_LOGEMENT(state, type) {
      const previousType = state[storeName].floor.type_logement;
      if (isSpecialLogementType(previousType)) {
        state[storeName].floor.cave = null;
        state[storeName].floor.floor = '';
      }
      if (isSpecialLogementType(type)) {
        state[storeName].floor.cave = 0;
        state[storeName].floor.floor = '0';
      }
      state[storeName].floor.type_logement = type;
    },
    SET_LIFT(state, lift) {
      state[storeName].floor.lift = lift;
      if (!lift) {
        state[storeName].floor.all_in_lift = null;
        state[storeName].floor.lift_comment = '';
      }
    },
    SET_LIFT_COMMENT(state, comment) {
      state[storeName].floor.lift_comment = comment;
    },
    SET_CAVE(state, cave) {
      state[storeName].floor.cave = cave;
    },
    SET_ALL_IN_LIFT(state, all_in_lift) {
      state[storeName].floor.all_in_lift = all_in_lift;
      if (all_in_lift === 1) {
        state[storeName].floor.mm_utilisable = null;
        state[storeName].floor.mm_obligatoire = null;
        state[storeName].floor.stairs = null;
      }
    },
    SET_MM_OBLIGATOIRE(state, mm) {
      state[storeName].floor.mm_obligatoire = mm;
    },
    SET_MM_UTILISABLE(state, mm) {
      state[storeName].floor.mm_utilisable = mm;
      if (mm === 0) {
        state[storeName].floor.mm_obligatoire = null;
      } else if (state[storeName].floor.stairs === 1
          || state[storeName].floor.stairs === -1) {
        state[storeName].floor.mm_obligatoire = 1;
      }
    },
    SET_STAIRS(state, stairs) {
      state[storeName].floor.stairs = stairs;
      if (stairs === 0) {
        state[storeName].floor.mm_obligatoire = null;
      } else if (state[storeName].floor.mm_utilisable === 1
          || state[storeName].floor.mm_utilisable === -1) {
        state[storeName].floor.mm_obligatoire = 1;
      }
    },
    SET_FLOOR(state, floor) {
      state[storeName].floor.floor = floor.toString();
    },
    SET_ADDRESS(state, address) {
      state[storeName].address = address;
    },
    SET_PARKING_TYPE(state, type) {
      state[storeName].parking.type = type;
    },
    SET_PARKING_PORTAGE(state, portage) {
      state[storeName].parking.portage = portage;
    },
    SET_PARKING_VL(state, vl) {
      state[storeName].parking.vl = vl;
    },
  };
}

export function isValidAddressForm(form, isAddressKnown) {
  const isAddressOk = !isAddressKnown || !isUnknownStreet(form);
  return isAddressOk
    && isValidPostal(form)
    && isValidCity(form);
}

export function isValidHousingForm(form) {
  return form
    && form.floor
    && form.floor.type_logement && form.floor.type_logement !== 'DGTS_LOG_UNDEFINED'
    && (form.floor.cave === 1 || form.floor.cave === -1 || form.floor.cave === 0)
    && isValidFloor(form);
}

export function isValidElevator(form) {
  return (
    form.floor && form.floor.lift !== null
      && form.floor.lift === false
  )
    || (form.floor && form.floor.lift && form.floor.lift_comment);
}

function isLiftValid(form) {
  return form && form.floor.lift !== null;
}

function isLiftCommentValid(form) {
  return form
    && ((form.floor.lift === true && form.floor.lift_comment !== '')
      || (form.floor.lift === false));
}

function isAllInLiftValid(form) {
  return form
    && ((form.floor.lift === true && form.floor.all_in_lift != null)
        || (form.floor.lift === false));
}

function isStairValid(form) {
  return form
    && ((form.floor.stairs === null
      && form.floor.lift === true
      && form.floor.lift_comment !== ''
      && form.floor.all_in_lift === 1)
      || (form.floor.all_in_lift !== 1
        && form.floor.stairs !== null)
    );
}

function isMMUtilisableValid(form) {
  return form
  && ((form.floor.all_in_lift !== 1 && form.floor.mm_utilisable != null)
      || form.floor.all_in_lift === 1);
}

function isMMObligatoireValid(form) {
  return form
  && (((form.floor.mm_utilisable === 1
      || form.floor.mm_utilisable === -1) && form.floor.mm_obligatoire != null)
      || (form.floor.mm_utilisable === 0 || form.floor.mm_utilisable === null));
}

export function isValidFurnitureTransportForm(form) {
  return isLiftValid(form)
    && isLiftCommentValid(form)
    && isAllInLiftValid(form)
    && isStairValid(form)
    && isMMUtilisableValid(form)
    && isMMObligatoireValid(form);
}

function validateParking(form) {
  return form
    && form.parking
    && form.parking.vl !== null
    && form.parking.type !== ''
    && form.parking.portage;
}

export function isValidParkingArea(form) {
  return validateParking(form);
}
